import React from "react"

import Layout from "../components/Layout"
import HomeBanner from "../components/sections/HomeBanner"
import About from "../components/sections/About/"
import BannerDetalhes from "../components/sections/BannerDetalhes"
import BannerBenefits from "../components/sections/BannerBenefits"
import TechnologiesList from "../components/sections/TechnologiesList"
import PortfolioDestaques from "../components/sections/PortfolioDestaques"
import Depoimentos from "../components/sections/Depoimentos"
import BlogDestaques from "../components/sections/BlogDestaques"
import Contact from "../components/sections/Contact"

const Index = ({ location }) => {
  return (
    <Layout location={location} seo={{ title: "Home" }}>
      <HomeBanner />
      <About />
      <TechnologiesList />
      <BannerDetalhes />
      <BannerBenefits />
      <PortfolioDestaques />
      <Depoimentos />
      <BlogDestaques />
      <Contact />
    </Layout>
  )
}

export default Index
